import { InvestmentReasonsService } from './../../../@core/utils/investment-reasons.service';
import { InflationService } from './../../../@core/utils/inflation.service';
import { SpreadsheetColumnsService } from './../../../@core/utils/spreadsheet-columns.service';
import { SpreadsheetColumnsInvestmentsService } from './../../../@core/utils/spreadsheet-columns-investments.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbButtonModule, NbCardModule, NbDialogService } from '@nebular/theme';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GridOptions, IServerSideDatasource, MenuItemDef } from 'ag-grid-community';
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { debounceTime, filter, finalize, first, map, shareReplay, skip, switchMap, tap } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import {
  ChartsService,
  ConfigService,
  ExportsService,
  InitiativesService,
  InvestmentScenariiService,
  InvestmentsChangesService,
  InvestmentsService,
  InvestmentStatusesService,
  PerimetersService,
  PostponementsService,
  QuickFiltersService,
  QuotePartService,
  ScopeService,
  SaveToastService,
  UsersService,
  YearsService,
} from '../../../@core/utils';
import {
  AG_GRID_INVESTMENT_FILTERS,
  INVEST_FILTER_KEY_PREFIX,
  TABLE_FILTER_ICON,
} from '../../../@core/utils/constants';
import { I18nService } from '../../../@core/utils/i18n.service';
import { idMapToArray } from '../../../@core/utils/scope.service';
import { TableFilterColumns } from '../../../@core/utils/spreadsheet-columns.service';
import { AgGridBaseComponent } from '../ag-grid-base/ag-grid-base.component';
import * as R from 'ramda';
import {
  InvestmentChangeConfirmDialogComponent,
} from '../investment-change-confirm-dialog/investment-change-confirm-dialog.component';
import { RowNode } from 'ag-grid-community';
import { CheckboxRendererComponent } from '../ag-grid-renderers/checkbox-renderer.component';
import { agIconLoadingTemplate } from '../circular-spinner/circular-spinner';
import { AgGridAngular } from 'ag-grid-angular';
import { TableFilterComponent } from '../table-filter/table-filter.component';
import { OutsideClickDirective } from '../../directives/outside-click.directive';
import { InvestmentFormComponent } from '../side-forms/investment-form/investment-form.component';
import { BasicDialogComponent } from '../basic-dialog/basic-dialog.component';
import { QuotePartItem } from '../../../@core/api/models';
import {
  InvestmentQuotePartDialogComponent,
} from '../site-overview/investment-quote-part-dialog/investment-quote-part-dialog.component';
import { InvestmentWizardRootComponent } from '../wizards/investment-wizard/wizard-index.component';
import {
  DialogWithCheckboxOptionComponent,
} from '../dialog-with-checkbox-option/dialog-with-checkbox-option.component';
import {
  SendInvestmentEmailDialogComponent,
  SendInvestmentEmailResult,
} from '../send-investment-email-dialog/send-investment-email-dialog.component';
import { LastTechnicalStateFilterComponent } from '../ag-grid-filters/last-technical-state-filter.component';
import { LastTechnicalStateRendererComponent } from '../ag-grid-renderers/last-technial-state-render.component';
import { LinkedInvestmentsHeaderComponent } from '../ag-grid-renderers/linked-investments-header.component';
import { RightPanelDialogService } from '../../../@core/utils/right-panel-dialog.service';
import { LinkableInvestmentsListComponent } from '../side-forms/linkable-investments-list/linkable-investments-list.component';

@Component({
  selector: "app-ag-grid-investment",
  templateUrl: "./ag-grid-investment.component.html",
  styleUrls: ["./ag-grid-investment.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NbCardModule, OutsideClickDirective, TableFilterComponent, AgGridAngular, TranslateModule, NbButtonModule]
})
export class AgGridInvestmentComponent extends AgGridBaseComponent implements OnInit, OnChanges, OnDestroy {
  quotePartService = inject(QuotePartService);
  sideFormService = inject(RightPanelDialogService);

  constructor(
    protected baseSpreadsheetColumnsService: SpreadsheetColumnsService,
    protected quickFiltersService: QuickFiltersService,
    protected route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private scope: ScopeService,
    private usersService: UsersService,
    private investmentStatusesService: InvestmentStatusesService,
    private i18n: I18nService,
    private spreadsheetColumnsService: SpreadsheetColumnsInvestmentsService,
    private yearsService: YearsService,
    private investmentsChangesService: InvestmentsChangesService,
    private dialogService: NbDialogService,
    private perimetersService: PerimetersService,
    private exportService: ExportsService,
    private chartsService: ChartsService,
    private inflationService: InflationService,
    private investmentScenariiService: InvestmentScenariiService,
    private postponementsService: PostponementsService,
    private investmentReasonsService: InvestmentReasonsService,
    private cdRef: ChangeDetectorRef,
    private investmentsService: InvestmentsService,
    private config: ConfigService,
    private initiativeService: InitiativesService,
    private saveToast: SaveToastService
  ) {
    super(baseSpreadsheetColumnsService, quickFiltersService, route);
  }

  protected spreadsheetType: KPI.SpreadsheetType = "investment";

  @ViewChild("grid") grid: ElementRef;
  @ViewChild('agGrid') agGrid!: AgGridAngular;

  @Input() public showScenarii: boolean;
  @Input() public summaryInvestmentStatus: KPI.InvestmentStatus;
  @Input() public showAddButton: boolean = true;
  @Input() public investmentsListColumns: string[] = [];
  private _investmentsListFilter: any;
  @Input() public set investmentsListFilter(value: any) {
    this._investmentsListFilter = value;
  }
  public get investmentsListFilter(): any {
    return this._investmentsListFilter;
  }
  @Input() public investmentsListForcedScenario: KPI.InvestmentScenario;
  @Input() public applyPeriod: boolean = true;
  @Input() public isFidjiAct: boolean = false;

  public filteredInvestNb = 0;
  public filteredInvestAmount = "0";
  public selectedRowsNb = 0;
  public loadedRowsNb = 0; // Number of rows loaded in the table
  public rowMax = 0; // Max number of rows in the table
  public cacheBlockSize = 100; // Number of rows to load at once
  public filtersNb: number = 0;
  public filteredColumns: string[] = [];
  private mainScenario$: Observable<KPI.InvestmentScenario> = this.investmentScenariiService.mainScenario$;
  public loading: boolean = false;
  public canAccessAudit: boolean;
  public customerConfig: KPI.CustomerConfig = null;
  public gridOptions: GridOptions;
  private isPPA: boolean;
  private allowedTransitions: KPI.AllowedStatusTransition[] = [];
  private investmentStatuses: KPI.InvestmentStatus[] = [];
  private investmentTypes: KPI.InvestmentType[] = [];
  private reasons: KPI.PostponementReason[] = [];
  private investmentReasons: KPI.InvestmentReason[] = [];
  private usersTransitions: KPI.AllowedStatusTransition[] = [];
  private filtersLocalStorageKey = AG_GRID_INVESTMENT_FILTERS;
  private filterKeyPrefix = INVEST_FILTER_KEY_PREFIX;
  private loadingColumnsAndFilters: boolean = true; // Flag meaning it's the first grid loading
  private finishedFirstFiltering: boolean = false;
  private cachedFiltersAlreadyApplied: boolean = false; // Flag to prevent re-applying cached filters on scope change
  private userOpenedFilter: boolean = false;
  private scenarii: KPI.InvestmentScenario[] = [];
  private quoteParts: QuotePartItem[] = [];

  private quotePartEnabled = false;
  private pendingOperations: (() => void)[] = [];
  private isGridReady = false;
  private permissions: KPI.PerimeterPermission[] = [];
  private newInvestment: KPI.Investment = null;
  public newInvestmentId: number = null;

  ngOnChanges(changes: SimpleChanges) {
    this.exportService.investmentExportReady.next(false);
    this.isPPA = this.router.url.includes("/decision/spreadsheet") || this.router.url.includes("/energy");
    this.config.customerConfig$.subscribe(conf => {
      this.canAccessAudit = conf.can_access_audit_app;
      this.customerConfig = conf;
    });
    this.subscriptions.push(
      this.config.customerConfig$.subscribe(conf => (this.canAccessAudit = conf.can_access_audit_app)),
      this.postponementsService.postponementReasons$.subscribe(reasons => (this.reasons = reasons)),
      this.usersService.currentUserPerimeterPermissions$.subscribe(permissions => (this.permissions = permissions)),
      this.baseSpreadsheetColumnsService.deleteInvestFilters$.subscribe(deleteFilters => {
        if (deleteFilters && this.gridApi) {
          Object.keys(this.gridApi.getFilterModel()).map(k => {
            this.gridApi.destroyFilter(k);
          });
          this.userOpenedFilter = true;
          this.gridApi.onFilterChanged();
          this.gridApi.closeToolPanel();
          localStorage.setItem(this.filtersLocalStorageKey, JSON.stringify({}));

          this.route.queryParams.pipe(first()).subscribe(params => {
            const filterKeys = Object.keys(params).filter((key) => key.startsWith(this.filterKeyPrefix));
            if (filterKeys.length > 0) {
              const queryParams: any = {};
              Object.keys(params).forEach(key => {
                if (!key.startsWith(this.filterKeyPrefix)) {
                  queryParams[key] = params[key];
                }
              });

              this.router.navigate([], {
                relativeTo: this.route,
                queryParams: queryParams,
                replaceUrl: true
              });
            }
          });

          this.urlParamsApplied = false;

          this.filtersNb = 0;
          this.filteredColumns = [];
          this.cdRef.detectChanges();
        }
      }),
      this.baseSpreadsheetColumnsService.openInvestFilters$.subscribe(openFilters => {
        if (openFilters && this.gridApi) {
          this.gridApi.openToolPanel("columns");
        } else if (!openFilters && this.gridApi) {
          this.gridApi.closeToolPanel();
        }
      }),
    );

    if (
      !changes.summaryInvestmentStatus ||
      (changes.summaryInvestmentStatus && changes.summaryInvestmentStatus.isFirstChange) // && (changes.scenario && changes.scenario.firstChange)
    ) {
      if (!this.gridOptions) {
        this.gridOptions = {
          components: {
            checkboxRenderer: CheckboxRendererComponent,
            lastTechnicalStateFilter: LastTechnicalStateFilterComponent,
            lastTechnicalStateRenderer: LastTechnicalStateRendererComponent,
            linkedInvestmentsHeader: LinkedInvestmentsHeaderComponent,
          },
          overlayLoadingTemplate: agIconLoadingTemplate,
          overlayNoRowsTemplate: `
            <div>
              ${this.translate.instant("pages.common.ag-grid.no_investment_found")}
            </div>
          `,
          rowBuffer: 10, // Draw 100 rows above and below the visible rows (Performance)
          allowDragFromColumnsToolPanel: true, // Allow user to move columns from panel
          cellSelection: {
            suppressMultiRanges: false
          },
          rowSelection: "multiple", // Enable to select the entire row instead of a cell
          rowModelType: "serverSide",
          allowContextMenuWithControlKey: true,
          serverSideDatasource: this.serverSideDatasource(),
          blockLoadDebounceMillis: 100,
          cacheBlockSize: this.cacheBlockSize,
          getRowId: params => {
            if (params.data && params.data.id !== undefined && params.data.id !== 0) {
              const pieces = [params.data.id, params.data.site || '', params.data.investment_label || ''];
              Object.keys(params.data).forEach(key => {
                if (key.startsWith('year_scenario_') || key.startsWith('status_scenario_')) {
                  pieces.push(params.data[key]);
                }
              });
              return pieces.join('_');
            }
            return `placeholder_${Math.random()}`;
          },
          suppressPropertyNamesCheck: true,
          columnMenu: "new",
          rowHeight: 28,
          icons: {
            columnGroupOpened: '<i class="ms-2 far fa-minus"/>',
            columnGroupClosed: '<i class="ms-2 far fa-plus"/>',
            filter: TABLE_FILTER_ICON
          },
          onCellKeyDown: params => {
            const KEY_A = "A";
            const event = params.event;
            const key = event["key"];
            if (((event["ctrlKey"] || event["metaKey"]) && KEY_A === key) || key.toUpperCase() === KEY_A) {
              const rowNodes = [];
              this.gridApi.forEachNode(node => {
                if (node?.data?.id) rowNodes.push(node);
              });
              const getRowIndex = node => this.gridApi.getDisplayedRowAtIndex(node.rowIndex).rowIndex;
              // Get rowNode with minimal rowIndex
              const firstRowNode = rowNodes.reduce((acc, cur) => (getRowIndex(acc) < getRowIndex(cur) ? acc : cur));
              const lastRowNode = rowNodes.reduce((acc, cur) => (getRowIndex(acc) > getRowIndex(cur) ? acc : cur));
              const visibleColumns = this.gridApi.getAllDisplayedColumns();
              this.gridApi.clearRangeSelection();
              this.gridApi.addCellRange({
                rowStartIndex: getRowIndex(firstRowNode),
                rowEndIndex: getRowIndex(lastRowNode),
                columns: visibleColumns
              });
            }
          },
          defaultColDef: {
            sortable: true,
            resizable: true,
            editable: false,
            filter: true,
            icons: {
              filter: TABLE_FILTER_ICON
            },
            // suppressKeyboardEvent: (params) => this.suppressNavigation(params),
            wrapHeaderText: true,
            autoHeaderHeight: true,
            enableCellChangeFlash: true, // Flash cell after updated
            menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
            suppressHeaderMenuButton: true,
            headerClass: params => {
              const field = (params.colDef as any)?.field;
              if (this.investmentsListFilter && field && field in this.investmentsListFilter) {
                return 'ag-header-default-filter';
              }
              return null;
            },
            filterParams: {
              excelMode: "windows",
              values: params => {
                if (params && params.colDef && params.colDef.field) {
                  this.subscriptions.push(
                    combineLatest([this.perimetersService.perimeters$, this.yearsToUse$, this.mainScenario$])
                      .pipe(
                        switchMap<any, Observable<any[]>>(([perimeters, [start_year, end_year], scenario]) => {
                          const fullFilterModel = params.api.getFilterModel() || {};
                          const currentColumnField = params.colDef.field;
                          const availableFilterField = params.colDef.availableFilterField;

                          const filterModelWithoutCurrentColumn = { ...fullFilterModel };
                          if (currentColumnField && filterModelWithoutCurrentColumn[currentColumnField]) {
                            delete filterModelWithoutCurrentColumn[currentColumnField];
                          }
                          if (availableFilterField && filterModelWithoutCurrentColumn[availableFilterField]) {
                            delete filterModelWithoutCurrentColumn[availableFilterField];
                          }

                          return this.quickFiltersService.getAvailableFilterValues(
                            availableFilterField || currentColumnField,
                            {
                              buildings: PerimetersService.getBuildingsIds(perimeters),
                              start_year,
                              end_year,
                              scenario: scenario.id,
                              filterModel: filterModelWithoutCurrentColumn,
                              table: "Investment"
                            }
                          );
                        })
                      )
                      .subscribe((res: any[]) => params.success(params.colDef.notNull ? [...res] : [null, ...res]))
                  );
                }
              },
              // Disable ag-grid's default filter values sorting
              comparator: (_a, _b) => {}
            },
            aggFunc: "first",
            cellStyle: params => {
              if (params.column?.isFilterActive()) {
                return { color: "#ff6c6c" };
              }
              return {};
            }
          },
          rowClassRules: {
            "d-none": row => !row?.data?.id
          },
          getRowStyle: params => {
            if (params?.data?.id && params.data.id === params.context?.newInvestmentId) {
              return { background: '#bfe1fd' };
            }
            return null;
          },
          columnDefs: [], // Columns definition (Set it later)
          animateRows: true, // Row animations (when expanding)
          // Always show the column menus
          suppressMenuHide: true,
          groupHeaderHeight: 32, // Show group only when scenarii are displayed
          groupRemoveSingleChildren: true, // Remove the row groups with only one row inside
          context: this,
          tooltipShowDelay: 0,
          // Restrict aggregations some functions (sum in an ag-grid native one)
          onGridReady: params => {
            this.gridApi = params.api;
            let colsThatNeedFilterValues = [];
            let colsAvailableFilterKeyMap: any = {};
            let cachedFilterModel: any = null;
            this.subscriptions.push(
              // Load investments data if on the PPA or single-page investments page
              this.spreadsheetColumnsService
                .getAgGridInvestmentColumns(this.showScenarii, this.investmentsListForcedScenario, this.isFidjiAct)
                .pipe(
                  tap(cols => {
                    cols.map(colGrp =>
                      colGrp.children?.map(
                        (col: KPI.CustomColDef) => {
                          colsAvailableFilterKeyMap[col.field] = col.availableFilterField || col.field;
                          if (col.field === 'investment_label' ||
                              col.field === 'label' ||
                              col.field === 'asset_label' ||
                              col.headerName === 'Label') {
                            col.enableCellChangeFlash = false;
                          }
                        }
                      )
                    );

                    this.gridApi.setGridOption("columnDefs", cols);
                    this.restoreState();
                    // @ts-ignore
                    this.gridApi.getToolPanelInstance("columns")?.collapseColumnGroups();
                    this.reorderScenarioColumns();
                  }),
                  switchMap(() => this.isUrlParamsFilters()),
                  switchMap((isUrlParamsFilters) => {
                    if (isUrlParamsFilters) {
                      cachedFilterModel = null;
                      return this.applyURLParamsFilters().pipe(
                        tap((cols: TableFilterColumns[]) => colsThatNeedFilterValues.push(...cols))
                      );
                    } else if (!this.isInputFilter() && this.isPPA) {
                      cachedFilterModel = this.getCachedFilterModel();
                      if (!Object.keys(cachedFilterModel).length) {
                        cachedFilterModel = this.getDefaultFilterModel();
                      }
                      colsThatNeedFilterValues = Object.keys(cachedFilterModel);
                      this.cachedFiltersAlreadyApplied = true;
                    }
                    return of([]);
                  }),
                  switchMap(() => this.applyInputFilters()),
                  tap((cols: TableFilterColumns[]) => colsThatNeedFilterValues.push(...cols)),
                  switchMap(() => (this.isPPA ? this.applyQuickFilters() : of([]))),
                  tap((cols: TableFilterColumns[]) => colsThatNeedFilterValues.push(...cols)),
                  map(quickFilterCols => !!quickFilterCols?.length),
                  switchMap(isQuickFiltered => {
                    this.isQuickFiltered = isQuickFiltered;
                    if (colsThatNeedFilterValues?.length) {
                      return combineLatest([
                        this.perimetersService.perimeters$,
                        this.yearsToUse$,
                        this.mainScenario$.pipe(shareReplay(1))
                      ]).pipe(
                        switchMap(([perimeters, [start_year, end_year], scenario]) => {
                          // Make sure all the filter values are pre-loaded before applying the filters
                          return combineLatest([
                            ...colsThatNeedFilterValues.map(colId =>
                              this.quickFiltersService.getAvailableFilterValues(
                                colsAvailableFilterKeyMap[colId] || colId,
                                {
                                  buildings: PerimetersService.getBuildingsIds(perimeters),
                                  start_year,
                                  end_year,
                                  scenario: scenario.id,
                                  table: "Investment",
                                  ...{ filterModel: this.gridApi.getFilterModel() }
                                }
                              )
                            )
                          ]);
                        })
                      );
                    } else {
                      return of([]);
                    }
                  }),
                  debounceTime(500)
                )
                .subscribe(() => {
                  if (cachedFilterModel && Object.keys(cachedFilterModel).length) {
                    this.applyCachedFilterModel(cachedFilterModel);
                    this.filtersNb = Object.keys(cachedFilterModel).length;
                    this.filteredColumns = Object.keys(cachedFilterModel);
                    this.cdRef.detectChanges();
                  }

                  this.finishedFirstFiltering = true;
                  this.urlParamsApplied = true;
                  this.inputFiltersApplied = true;
                  this.gridApi.onFilterChanged();
                  this.gridApi?.refreshServerSide();
                })
            );
          },
          // Hook executed after first data set
          onFirstDataRendered: () => {
            // Force these columns to be display at the start of the table
            if (this.gridApi && this.investmentsListColumns?.length) {
              this.investmentsListColumns = this.investmentsListColumns.filter(
                col => !this.gridApi.getColumnDef(col)?.lockPosition
              );
              setTimeout(() => {
                this.gridApi.moveColumns(this.investmentsListColumns, 3);
                this.gridApi.setColumnsVisible(this.investmentsListColumns, true);
              }, 200);
            }
            this.loadingColumnsAndFilters = false; // End the first loading
            this.exportService.investmentExportReady.next(true);
            this.gridApi.hideOverlay();
            this.cdRef.detectChanges();
            this.quickFiltersReady.emit(true);
          },
          // Hook executed after each data update
          onRowDataUpdated: () => {
            if (this.gridApi) {
              this.gridApi.moveColumns(["row_nb"], 0);
              this.gridApi.setColumnsVisible(["row_nb"], true);
              setTimeout(() => this.gridApi?.refreshCells({ columns: ["row_nb"], force: true }));
            }
            this.exportService.investmentExportReady.next(true);
            this.gridApi.hideOverlay();
            this.cdRef.detectChanges();
          },
          onSortChanged: () => {
            if (this.gridApi) {
              setTimeout(() => this.gridApi?.refreshCells({ columns: ["row_nb"], force: true }));
            }
          },
          onStateUpdated: () => {
            if (!this.isInputFilter()) {
              this.saveState();
            }
          },
          onColumnGroupOpened: () => {
            if (!this.isInputFilter()) {
              this.saveState();
            }
          },
          onFilterOpened: event => {
            // This is a hack to check if the user has opened at least one filter in order
            // to differenciate filter changes from user and the ones from the code itself
            if (event.source !== "NO_UI") {
              this.userOpenedFilter = true;
            }
          },
          onFilterChanged: () => {
            if (this.gridApi) {
              this.clearSelection();
              const filterModel = this.gridApi.getFilterModel();
              const filtersNb = Object.keys(filterModel).length;
              this.filtersNb = filtersNb;
              this.filteredColumns = Object.keys(filterModel);
              this.cdRef.detectChanges();

              if (
                !this.loadingColumnsAndFilters &&
                this.isPPA &&
                (this.userOpenedFilter || this.isQuickFiltered) &&
                !this.isInputFilter()
              ) {
                this.subscriptions.push(
                  this.isUrlParamsFilters()
                    .pipe(filter(isUrlParamsFilters => !isUrlParamsFilters))
                    .subscribe(() => {
                      // Save filters model in cache
                      localStorage.setItem(this.filtersLocalStorageKey, JSON.stringify(filterModel));
                    })
                );
              }
              this.quickFiltersService.setFiltersFromSpreadsheet("investment", filterModel);
              setTimeout(() => this.gridApi?.refreshCells({ columns: ["row_nb"], force: true }));
            }
          },
          onColumnVisible: params => {
            this.gridApi.moveColumns(["row_nb"], 0);

            const isImpactColumn = params.columns.some(
              col => col["parent"]?.providedColumnGroup?.colGroupDef?.field === "impacts_group"
            );
            if (isImpactColumn) {
              this.gridApi.setColumnsVisible(["empty_impact"], true);
            }
            this.gridApi.setColumnsVisible
            this.gridApi.setColumnsVisible(
              [
                "empty_payers",
                "empty_perimeter_info",
                "empty_info",
                "empty_doc",
                "empty_import",
                "empty_nomenclature",
                "empty_key",
                "empty_budget_category",
                "empty_quote_part",
                "empty_code",
                "empty_linked_asset",
              ],
              true
            );
            combineLatest([
              this.scope.config$,
              this.scope.investmentSponsors$.pipe(idMapToArray()),
              this.perimetersService.perimeters$
            ])
              .pipe(
                filter(([config, _]) => !!config.quote_part_enabled),
                filter(([_, sponsors, perimeters]) => !!sponsors && !!perimeters && perimeters.length === 1),
                tap(([_, investmentSponsors, perimeters]) => {
                  const site = perimeters[0],
                    defaultSponsors = investmentSponsors.filter(sponsor => sponsor.perimeters.includes(site.id));
                  this.gridApi.setColumnsVisible(
                    defaultSponsors.map(sponsor => `sponsorships_${sponsor.id}`),
                    true
                  );
                  this.gridApi.setColumnsVisible(
                    defaultSponsors.map(sponsor => `sponsorships_${sponsor.id}`),
                    true
                  );
                })
              )
              .subscribe();
          },
          getContextMenuItems: (params) => {
            if (!params.node || !params.node.data || !params.node.data.id || params.node.data.id === 0) {
              return [];
            }

            const columnId = params.column?.getColId();

            const isTagsOrImpactColumn = columnId?.includes('investment_reason_') ||
                                        columnId?.includes('impact_roadmap_indicators_');

            const columnDef = params.column?.getColDef();
            const isTagsOrImpactGroup = columnDef?.headerName === 'Tags' ||
                                       columnDef?.headerName === 'Impact' ||
                                       columnDef?.field === 'tags_group' ||
                                       columnDef?.field === 'impacts_group';

            const focusedCell = this.gridApi.getFocusedCell();
            const focusedColumnId = focusedCell?.column?.getColId();
            const isFocusedTagsOrImpact = focusedColumnId?.includes('investment_reason_') ||
                                         focusedColumnId?.includes('impact_roadmap_indicators_');

            if (isTagsOrImpactColumn || isTagsOrImpactGroup || isFocusedTagsOrImpact) {
              return [];
            }

            return this.buildContextMenu();
          },

          onCellDoubleClicked: params => {
            if (params.data?.id) {
              this.investmentsService
                .getInvestment(params.data?.id)
                .pipe(first())
                .subscribe(investment => {
                  this.sideFormService.open(
                    InvestmentFormComponent,
                    {
                      autoFocus: false,
                      closeOnBackdropClick: false,
                      context: {
                        investment: <KPI.MappedInvestment>investment
                      }
                    }
                  ).onClose.subscribe(() => {
                    this.gridApi.refreshServerSide();
                    const investRow = this.gridApi.getRowNode(investment.id.toString());
                    investRow?.setSelected(true);
                  })
                });
            }
          },
          onCellValueChanged: params => {
            if (typeof params?.newValue === "boolean") {
              this.investmentsChangesService.manageBooleanCellChange(params);
            }
          },
          onSelectionChanged: () => {
            this.setSelectedRowsNb();
          },
          onRangeSelectionChanged: () => {
            this.setSelectedRowsNb();
          },
          onCellFocused: () => {
            this.setSelectedRowsNb();
          },
          onRowSelected: () => {
            this.setSelectedRowsNb();
          },
          onCellClicked: (params) => {
            const columnId = params.column?.getColId();
            const isTagsOrImpactColumn = columnId?.includes('investment_reason_') ||
                                        columnId?.includes('impact_roadmap_indicators_');
            if (isTagsOrImpactColumn) {
              params.event?.stopPropagation();
              params.event?.preventDefault();
              setTimeout(() => {
                const contextMenu = document.querySelector('.ag-menu');
                if (contextMenu) {
                  (contextMenu as HTMLElement).style.display = 'none';
                  (contextMenu as HTMLElement).remove();
                }
                this.gridApi.hideOverlay();
              }, 0);
            }
          },
          onCellContextMenu: (params) => {
            const columnId = params.column?.getColId();
            const isTagsOrImpactColumn = columnId?.includes('investment_reason_') ||
                                        columnId?.includes('impact_roadmap_indicators_');
            if (isTagsOrImpactColumn) {
              params.event?.stopPropagation();
              params.event?.preventDefault();
              return false;
            }
          }
        };

        // Add the side bar to pages but not on postponements
        this.gridOptions.sideBar = {
          toolPanels: [
            {
              id: "columns",
              labelDefault: this.translate.instant("pages.common.ag-grid.columns"),
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
              // Hide every other tools
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
              }
            },
            {
              id: "filters",
              labelDefault: this.translate.instant("pages.common.ag-grid.filters"),
              labelKey: "filters",
              iconKey: "filter",
              toolPanel: "agFiltersToolPanel"
            }
          ],
          position: "right" // Can set the side bar on the left or on the right
          // Set this to open the sidebar by default on columns panel
          // defaultToolPanel: 'columns',
        };

        (this.gridOptions as any).cellFlashDuration = 2000;
        (this.gridOptions as any).cellFadeDuration = 500;

        this.subscriptions.push(
          this.spreadsheetColumnsService.getAgGridTranslations().subscribe(agGridTranslations => {
            this.gridOptions.localeText = agGridTranslations;
          })
        );
      }
    }
    if (this.isGridReady && this.gridApi) {
      this.applyFilters();
    } else {
      this.pendingOperations.push(() => this.applyFilters());
    }
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.isGridReady = true;
    this.pendingOperations.forEach(op => op());
    this.pendingOperations = [];
    const filterModel = this.gridApi.getFilterModel();
    this.expandTabsBasedOnFilters(filterModel);
    this.subscriptions.push(
      this.investmentsService.newInvestmentCreated$.subscribe(newInvestment => {
        this.newInvestment = newInvestment;
      })
    )
  }

  private applyFilters(): void {
    const savedFilterModel = localStorage.getItem("investmentFilters");
    if (savedFilterModel) {
      const filterModel = JSON.parse(savedFilterModel);
      this.gridApi.setFilterModel(filterModel);
      this.gridApi.onFilterChanged();
    }
  }

  private getGroupFromFilter(column: string): string | null {
    const columnDefs = this.gridApi.getColumnDefs() as any;
    const columnDef = columnDefs.find((col: any) => col.field === column);
    if (columnDef) {
      if (columnDef?.parent?.colGroupDef?.headerName === "Impact") {
        return "Impact";
      } else if (columnDef?.parent?.colGroupDef?.headerName === "Tags") {
        return "Tags";
      }
    }
    if (columnDef?.parent?.colGroupDef?.headerName === "Impact") {
      return "Impact";
    } else if (columnDef?.parent?.colGroupDef?.headerName === "Tags") {
      return "Tags";
    }
    if (column.startsWith("impact_")) {
      return "Impact";
    } else if (column.startsWith("investment_reason_")) {
      return "Tags";
    }
    console.warn(`No group found for column: ${column}`);
    return null;
  }

  onFilterChanged(): void {
    if (this.gridApi) {
      const filterModel = this.gridApi.getFilterModel();
      this.expandTabsBasedOnFilters(filterModel);
      localStorage.setItem("investmentFilters", JSON.stringify(filterModel));
    }
  }

  private expandTabsBasedOnFilters(filterModel: any): void {
    let impactFilterApplied = false;
    let tagsFilterApplied = false;
    Object.keys(filterModel).forEach(column => {
      const group = this.getGroupFromFilter(column);
      if (group === "Impact") {
        impactFilterApplied = true;
      } else if (group === "Tags") {
        tagsFilterApplied = true;
      }
    });

    if (impactFilterApplied) {
      try {
        this.expandImpactGroup();
      } catch (error) {
        console.error("Error expanding Impact group:", error);
      }
    }
    if (tagsFilterApplied) {
      try {
        this.expandTagsGroup();
      } catch (error) {
        console.error("Error expanding Tags group:", error);
      }
    }
  }

  private expandImpactGroup(): void {
    const groupState = this.gridApi.getColumnGroupState();
    const impactGroup = groupState.find(group => group.groupId && this.isImpactGroup(group.groupId));
    if (impactGroup) {
      impactGroup.open = true;
      this.gridApi.setColumnGroupState([{ groupId: impactGroup.groupId, open: true }]);
    } else {
      console.warn("Impact group not found in column group state.");
    }
  }

  private isImpactGroup(groupId: string): boolean {
    const columnDefs = this.gridApi.getColumnDefs();
    const groupDef = columnDefs.find((col: any) => col.groupId === groupId);
    return groupDef?.headerName === "Impact";
  }

  private expandTagsGroup(): void {
    const groupState = this.gridApi.getColumnGroupState();
    const tagsGroup = groupState.find(group => group.groupId && this.isTagsGroup(group.groupId));
    if (tagsGroup) {
      tagsGroup.open = true;
      this.gridApi.setColumnGroupState([{ groupId: tagsGroup.groupId, open: true }]);
    } else {
      console.warn("Tags group not found in column group state.");
    }
  }

  private isTagsGroup(groupId: string): boolean {
    const columnDefs = this.gridApi.getColumnDefs();
    const groupDef = columnDefs.find((col: any) => col.groupId === groupId);
    return groupDef?.headerName === "Tags";
  }

  ngOnInit() {
    this.subscriptions.push(
      this.quotePartService.quoteparts$
        .pipe(
          tap(qps => (this.quoteParts = qps))
        )
        .subscribe(),
      this.investmentScenariiService.selectedScenarii$
        .pipe(map(scenarii => scenarii.filter(s => !!s)))
        .subscribe(scenarii => {
          this.scenarii = scenarii;
        }),
      this.investmentsChangesService.pendingChangesNumber$.subscribe(pendingChangesNumber => {
        if (pendingChangesNumber > 0) {
          this.gridApi.showLoadingOverlay();
          this.cdRef.detectChanges();
        } else if (!this.loadingColumnsAndFilters) {
          this.clearSelection();
          this.gridApi.refreshServerSide();
          this.gridApi.hideOverlay();
          this.cdRef.detectChanges();
        }
      }),
      combineLatest([this.chartsService._capexHasChanged$, this.chartsService._energyHasChanged$])
        .pipe(filter(() => !this.loadingColumnsAndFilters))
        .subscribe(() => {
          this.gridApi?.refreshServerSide();
        }),
      this.investmentsService.investmentLinksChanged$.subscribe(() => {
        // purge=true forces full row re-render so cellRenderer re-runs with fresh linked_invests_total / linked_to
        this.gridApi?.refreshServerSide({ purge: true });
      }),
      combineLatest([
        this.investmentStatusesService.getAllowedTransitionsStatus().pipe(first()),
        this.scope.investmentStatuses$.pipe(first(), idMapToArray()),
        this.scope.user$.pipe(first()),
        this.usersService.membersGroups$.pipe(first()),
        this.investmentReasonsService.investmentReasons$.pipe(first()),
        this.scope.config$.pipe(first()),
        this.scope.investmentTypes$.pipe(first(), idMapToArray())
      ]).subscribe(
        ([allowedTransitions, investmentsStatuses, currentUser, membersGroups, investmentReasons, config, investmentTypes]) => {
          this.allowedTransitions = allowedTransitions;
          this.investmentStatuses = investmentsStatuses;
          this.investmentReasons = investmentReasons;
          this.investmentTypes = investmentTypes;
          this.quotePartEnabled = config?.quote_part_enabled;

          /** Get Investment Statuses **/
          const currentUserGroups = membersGroups.filter(group => group.members.includes(currentUser.id));
          if (currentUserGroups) {
            // We recover all the transition allowed for the user
            currentUserGroups.forEach(group => {
              if (group.allowed_investment_status_transitions) {
                this.usersTransitions = this.usersTransitions.concat(
                  // @ts-ignore
                  group.allowed_investment_status_transitions
                );
              }
            });
          }
        }
      ),
      this.perimetersService.perimeters$
        .pipe(
          map(perimeters => (perimeters || []).length),

          tap(() => {
            if (this.gridApi && !this.loadingColumnsAndFilters && this.finishedFirstFiltering) {
              this.clearSelection();
              this.gridApi.refreshServerSide();
            }
          })
        )
        .subscribe(),
      this.yearsService.latestYears$
        .pipe(
          skip(1),
          debounceTime(300),
          filter(() => !!this.gridApi)
        )
        .subscribe(() => {
          this.clearSelection();
          // Clear filters if user hasn't manually opened/set filters (prevents cached filters from persisting on scope change)
          if (!this.userOpenedFilter && !this.isQuickFiltered && !this.isInputFilter()) {
            this.gridApi.setFilterModel(null);
            this.filtersNb = 0;
            this.filteredColumns = [];
            this.cdRef.detectChanges();
          }
          this.gridApi.refreshServerSide({ purge: true });
        })
    );
  }

  private isQuotePartAvailableForInvestment(qp: QuotePartItem, investment) {
    return (qp.site_id === investment.site && !qp.is_other) || (qp.investments.includes(investment.id) && qp.is_other);
  }

  /**
   * Build the cells context menu
   */
  protected buildContextMenu(): MenuItemDef[] {
    const contextMenu: MenuItemDef[] = []; // Initialize context menu
    this.gridApi.deselectAll();

    const scenarii: KPI.InvestmentScenario[] = this.investmentsListForcedScenario
      ? [this.investmentsListForcedScenario]
      : this.scenarii.filter(scenario => this.showScenarii || scenario.is_main);

    /**
     * Get data from selected rows
     */
    const rowNodes = this.getSelectedRows();

    // Has user permission ?
    // We consider that the user doesn't have permission if at least one site in the selection
    // is read_only
    const siteIds = rowNodes.map(node => node.data.site);
    const readOnlyPermissions = this.permissions.filter(
      perm => siteIds.includes(perm.perimeter) && perm.read_only
    );
    const readOnly = readOnlyPermissions?.length > 0;

    // True if single select - False if multiple (+ check if row is not a group)
    const isSingleSelect = rowNodes.length === 1;
    // Get investment ids from rows selected, and remove duplicate ids
    const investmentsIds = [
      ...new Set(
        rowNodes.map(rowNode => {
          if (rowNode && rowNode.data && rowNode.data.id) {
            return Number(rowNode.data.id);
          }
        })
      )
    ];
    if (rowNodes[0]) {
      /**
       * Change investment status
       */
      contextMenu.push({
        name: this.translate.instant("Change status"),
        disabled: readOnly ||
          !this.customerConfig?.is_show_edit ||
          (scenarii.length === 1 &&
            !(this.generateToStatusSubmenu(scenarii[0], true, rowNodes) as MenuItemDef[])?.length),
        tooltip:
          scenarii.length === 1 &&
          !(this.generateToStatusSubmenu(scenarii[0], true, rowNodes) as MenuItemDef[])?.length
            ? this.translate.instant("No status available from the current status")
            : "",
        subMenu:
          scenarii.length === 1
            ? (this.generateToStatusSubmenu(scenarii[0], true, rowNodes) as MenuItemDef[])
            : scenarii.map(scenario => {
                return this.generateToStatusSubmenu(scenario, false, rowNodes) as MenuItemDef;
              })
      });

      /**
       * Change investment year
       */
      const anyLocked = rowNodes.some(node => {
        const investmentInstance = (node.data?.scenarii_data || []).find((s) => !s.original_investment_id) || { status_id: null };
        return !!(this.investmentStatuses || []).find((status) => status.id === investmentInstance?.status)?.is_locked;
      });
      contextMenu.push({
        name: this.translate.instant("Change year"),
        disabled: readOnly || anyLocked || !this.customerConfig?.is_show_edit,
        subMenu:
          scenarii.length === 1
            ? (this.generateToYearsSubmenu(scenarii[0], true, rowNodes) as MenuItemDef[])
            : scenarii.map(scenario => {
                return this.generateToYearsSubmenu(scenario, false, rowNodes) as MenuItemDef;
              })
      });

      if (!isSingleSelect) {
        // Get tags common to all selected investments
        const commonTags = this.investmentReasons.filter(tag =>
          rowNodes.every(rowNode => !!rowNode?.data?.[`investment_reason_${tag.id}`])
        );

        // Available tags are the ones not already set on ALL the selected investments
        const availableTags = this.investmentReasons.filter(tag =>
          rowNodes.every(rowNode => !rowNode?.data?.[`investment_reason_${tag.id}`])
        );

        // Add and Remove a tag
        contextMenu.push(
          {
            name: this.translate.instant("Add a tag"),
            icon: '<i class="fa-kit fa-light-tags-circle-plus fa-lg"></i>',
            disabled: readOnly || !availableTags?.length,
            tooltip: !availableTags?.length ? this.translate.instant("No tag available") : "",
            subMenu: availableTags.map(tag => {
              return {
                name: tag.name,
                action: () => {
                  const dialog = this.dialogService.open(InvestmentChangeConfirmDialogComponent, {
                    autoFocus: false,
                    context: {
                      investmentsIds,
                      tag: tag.name,
                      addingTag: true
                    }
                  });
                  this.subscriptions.push(
                    dialog.onClose.pipe(filter(res => !!res)).subscribe(() => {
                      investmentsIds.forEach(investmentId => {
                        const investmentRow = rowNodes.find(rowNode => rowNode?.data?.id === investmentId);
                        if (investmentRow?.data) {
                          const investmentTagIds: number[] = [
                            ...new Set(this.getInvestmentTagIds(investmentRow).concat([tag.id]))
                          ];
                          this.gridApi.showLoadingOverlay();
                          this.cdRef.detectChanges();
                          this.investmentsChangesService.addChange(investmentId, "reasons", investmentTagIds);
                        }
                      });
                    })
                  );
                }
              };
            })
          },
          {
            name: this.translate.instant("Remove a tag"),
            icon: '<i class="fa-kit fa-light-tags-circle-minus fa-lg"></i>',
            disabled: readOnly || !commonTags?.length,
            tooltip: !commonTags?.length ? this.translate.instant("No tag to remove") : "",
            subMenu: commonTags.map(tag => {
              return {
                name: tag.name,
                action: () => {
                  const dialog = this.dialogService.open(InvestmentChangeConfirmDialogComponent, {
                    autoFocus: false,
                    context: {
                      investmentsIds,
                      tag: tag.name,
                      removingTag: true
                    }
                  });
                  this.subscriptions.push(
                    dialog.onClose.pipe(filter(res => !!res)).subscribe(() => {
                      investmentsIds.forEach(investmentId => {
                        const investmentRow = rowNodes.find(rowNode => rowNode?.data?.id === investmentId);
                        if (investmentRow?.data) {
                          const investmentTagIds: number[] = [
                            ...new Set(this.getInvestmentTagIds(investmentRow).filter(id => id !== tag.id))
                          ];
                          this.gridApi.showLoadingOverlay();
                          this.cdRef.detectChanges();
                          this.investmentsChangesService.addChange(investmentId, "reasons", investmentTagIds);
                        }
                      });
                    })
                  );
                }
              };
            })
          }
        );
      }

      // Distribution key — available for any scope (single or multiple sites)
      if (this.quotePartEnabled) {
        const allSameQuotePart = rowNodes.every(
          r => r.data.quote_part?.id === rowNodes[0].data.quote_part?.id
        );
        const isAnyLocked = rowNodes.some(r =>
          !!(this.investmentStatuses || []).find(
            s => s.id === (r.data.scenarii_data || []).find(i => !i.original_investment_id)?.status
          )?.is_locked
        );
        const availableQuoteParts = this.quoteParts.filter(qp =>
          rowNodes.every(r => this.isQuotePartAvailableForInvestment(qp, r.data))
        );

        const chooseQuotePartSubmenu = availableQuoteParts.map((quotePart) => {
          const isUsing = allSameQuotePart && quotePart && quotePart.id === rowNodes[0].data.quote_part?.id;
          return {
            disabled: readOnly || isUsing,
            name: (isUsing ? "✓ " : "") + quotePart.name,
            action: () => this.bulkUpdateInvestmentQuotePart(rowNodes, quotePart)
          };
        });

        contextMenu.push({
          name: this.translate.instant("Choose distribution key"),
          disabled: readOnly || isAnyLocked || !allSameQuotePart || !this.customerConfig?.is_show_edit,
          tooltip: !allSameQuotePart
            ? this.translate.instant("Please select investments with the same distribution key")
            : '',
          subMenu: [
            ...chooseQuotePartSubmenu,
            {
              disabled: readOnly || !rowNodes[0].data.quote_part,
              name: this.translate.instant("quote_part.unknown"),
              action: () => this.bulkUpdateInvestmentQuotePart(rowNodes, { id: null } as QuotePartItem)
            }
          ]
        });

        // "View/modify" stays single-investment only (budget display is per-investment)
        if (rowNodes.length === 1) {
          const investment = rowNodes[0].data;
          const isLocked = (this.investmentStatuses || []).find(
            s => s.id === (investment.scenarii_data || []).find(i => !i.original_investment_id)?.status
          )?.is_locked;
          contextMenu.push({
            disabled: !investment.quote_part || !investment?.quote_part?.is_active || !this.customerConfig?.is_show_edit,
            name: this.translate.instant("quote_part.view_modify_the_quote_part"),
            action: () => { this.showInvestmentQuotePartOtherDialog(investment, isLocked); }
          });
        }
      }

      // Linked investments
      const selectedRowData = rowNodes[0]?.data;
      const hasLinked = !!(selectedRowData?.['linked_to'] || selectedRowData?.['links_from']?.length);

      contextMenu.push({
        name: this.translate.instant("See linked investments"),
        action: () => {
          this.openLinkedInvestmentsList(selectedRowData);
        },
        disabled: readOnly || !hasLinked
      });

      // Send an email about the selected investment (single select only)
      contextMenu.push({
        name: this.translate.instant("Send an email"),
        disabled: !isSingleSelect,
        action: () => {
          this.openSendEmailDialog(selectedRowData);
        }
      });

      // delete investment
      this.mainScenario$
        .pipe(
          first(),
          map((scenario) => scenario.id),
          // map scenarioId=> {id: 2798, status: 28, scenario_id: 1, final_schedule: 2025, ....}
          map((scenarioId) =>
            rowNodes[0].data?.scenarii_data?.find(scenariiData => scenariiData.scenario_id === scenarioId)
          ),
          // map investment.scenarii_data => InvestmentStatus
          map((sceanriiData) => this.investmentStatuses.find(status => status.id === sceanriiData.status)),
          filter((investmentStatus) => !!investmentStatus)
        )
        .subscribe((investmentStatus) => {
          // only enable when investment status is abandon, hypothesis or request
          const enabled = investmentStatus.is_cancelled ||
            investmentStatus.hypothesis ||
            investmentStatus.is_request;
          contextMenu.push({
            name: this.translate.instant("Delete"),
            disabled: readOnly || !enabled || investmentStatus.is_locked || !this.customerConfig?.is_show_edit,
            action: () => {
              this.deleteInvestment(rowNodes);
            }
          });
        });
    }

    if (readOnly) {
      contextMenu.forEach(menu => menu.disabled = true)
    }
    return contextMenu;
  }

  private openSendEmailDialog(rowData: any): void {
    const dialog = this.dialogService.open(SendInvestmentEmailDialogComponent, {
      autoFocus: false,
      context: {
        investmentLabel: rowData?.investment_label,
        siteId: rowData?.site,
        siteName: rowData?.site_name,
      }
    });

    this.subscriptions.push(
      dialog.onClose
        .pipe(
          first(),
          filter((res: SendInvestmentEmailResult) => !!res?.recipients?.length)
        )
        .subscribe((res: SendInvestmentEmailResult) => {
          this.investmentsService
            .sendInvestmentEmail(Number(rowData?.id), res.recipients, res.message)
            .subscribe({
              next: () => this.saveToast.showSaved(this.translate.instant("Email sent")),
              error: () =>
                this.saveToast.showError(this.translate.instant("Unable to send the email")),
            });
        })
    );
  }

  private showInvestmentQuotePartOtherDialog(
    investment: KPI.MappedInvestment & {
      budget: number;
    },
    readOnly: boolean
  ): void {
    const dialog = this.dialogService.open(
      InvestmentQuotePartDialogComponent,
      {
        autoFocus: false,
        context: {
          investment,
          readOnly
        }
      }
    );
    dialog.onClose
      .pipe(
        first(),
        filter(s => !!s?.reload),
        tap(() => this.gridApi.refreshServerSide())
      )
      .subscribe();
  }

  private deleteInvestment(rowNodes: RowNode[]) {
    const investmentsData = rowNodes.map((rowNode) => rowNode.data)
    const investmentLabel = rowNodes[0]?.data?.investment_label,
      investmentCount = rowNodes.length;
    const content =
      investmentCount === 1
        ? this.translate.instant("Do you confirm that {elementName} will be deleted ?", {
            elementName: investmentLabel
          })
        : this.translate.instant("Do you confirm that {elementName} investment(s) will be deleted ?", {
            elementName: investmentCount
          });
    const hasInitiatives = investmentsData.find(investData => investData.gains.length > 0);
    const option = hasInitiatives ? this.translate.instant('Also delete the linked actions') : "";

    const dialogRef = this.dialogService.open(
      DialogWithCheckboxOptionComponent,
      {
        autoFocus: false,
        context: {
          title: this.translate.instant("Delete"),
          content: content,
          option: option
        }
      }
    );
    let confirmDelete = false;
    dialogRef.onClose
      .pipe(
        first(),
        tap(dialogData => {
          confirmDelete = !!dialogData.confirmation;
        }),
        filter((dialogData) => !!dialogData.confirmation),
        switchMap((dialogData) =>
          forkJoin(investmentsData.map(
            (investData) => this.investmentsService.deleteInvestment(investData.id).pipe(
              switchMap(() => {
                if (dialogData.checked && investData.gains[0].initiative_id) {
                  // Delete the initiative
                  return this.initiativeService.deleteInitiative(investData.gains[0].initiative_id)
                } else {
                  return of(null)
                }
              })
            )
          ))
        ),
        finalize(() => {
          if (confirmDelete) {
            this.gridApi?.refreshServerSide();
          }
        })
      )
      .subscribe();
  }

  private updateTotalInvestmentBudget(filteredInvestNb: number, filteredInvestAmount: number, rowMax: number): void {
    this.filteredInvestNb = filteredInvestNb;
    this.filteredInvestAmount = this.i18n.formatCurrency(filteredInvestAmount) || "0 €";
    this.rowMax = rowMax;
    this.cdRef.detectChanges();
  }

  private updateInvestmentStatus(ids: number[], statusFrom: number, statusTo: number) {
    this.gridApi.showLoadingOverlay();
    this.cdRef.detectChanges();
    this.subscriptions.push(
      this.investmentStatusesService.updateMultipleInvestmentsStatus(ids, statusFrom, statusTo).subscribe({
        next: () => {
          // Refresh the investments observable with the refreshed investments
          // this.refreshInvestments(updatedInvestments);
          this.clearSelection();
          this.saveToast.showSaved();
          this.gridApi.hideOverlay();
          this.cdRef.detectChanges();
          // Force energy charts / cards to refresh after an initiative has been updated
          setTimeout(() => this.chartsService.capexHasChanged(), 500);
        },
        error: (error: HttpErrorResponse) => {
          console.error(error.error);
          this.gridApi.hideOverlay();
        }
      })
    );
  }

  private changeInvestmentsYear(ids: number[], fromYear: number, yearTo: number, reason: number): void {
    this.gridApi.showLoadingOverlay();
    this.cdRef.detectChanges();
    this.subscriptions.push(
      this.investmentsChangesService.changeInvestmentsYear(ids, fromYear, yearTo, reason).subscribe(() => {
        // Refresh the investments observable with the refreshed investments
        // this.refreshInvestments(updatedInvestments);
        this.clearSelection();
        this.gridApi.refreshServerSide();
        this.saveToast.showSaved();
        this.gridApi.hideOverlay();
        this.cdRef.detectChanges();
        // Force energy charts / cards to refresh after an initiative has been updated
        setTimeout(() => this.chartsService.capexHasChanged(), 500);
      })
    );
  }

  private buildFilterModelFromURL(params: any): any {
    const filterModel: any = {};

    if (!params) {
      return filterModel;
    }

    const filterKeys = Object.keys(params).filter((key) => key.startsWith(this.filterKeyPrefix));

    filterKeys.forEach(filterKey => {
      let column = filterKey.substring(this.filterKeyPrefix.length);

      let values = [];
      if (params[filterKey].includes('","')) {
        values = params[filterKey].split('","');
      } else {
        values = params[filterKey].split(",");
      }

      values = values.map(value => {
        if (value.indexOf('"') === 0) {
          value = value.substring(1);
          if (value.indexOf('"') === value.length - 1) {
            return value.substring(0, value.length - 1);
          }
          return value;
        } else if (value.indexOf('"') === value.length - 1) {
          return value.substring(0, value.length - 2);
        }
        if (value === "null") {
          return null;
        } else {
          return value;
        }
      });

      if (column === "investment_category") {
        const categoriesValues = values[0].split(" > ");
        for (let i = 1; i <= categoriesValues.length; i++) {
          filterModel[column + `_${i}`] = {
            filterType: "set",
            values: [categoriesValues[i - 1]]
          };
        }
      } else {
        filterModel[column] = {
          filterType: "set",
          values: values
        };
      }
    });

    return filterModel;
  }

  /**
   * Used to retrieve filters from URL and apply it on the grid's columns
   */
  private applyURLParamsFilters(): Observable<string[]> {
    const colsThatNeedFilterValues = [];
    return combineLatest([
      this.route.queryParams,
      this.scope.investmentStatuses$.pipe(first(), idMapToArray()),
      this.scope.taxonomyObjectives$.pipe(first(), idMapToArray())
    ]).pipe(
      switchMap(([params, investmentStatuses, taxonomyObjectives]) => {
        this.investmentStatuses = investmentStatuses;
        if (!this.urlParamsApplied && !this.isInputFilter()) {
          // Retrieve the filter keys from URL parameters
          const filterKeys = Object.keys(params).filter((key) => key.startsWith(this.filterKeyPrefix));
          const filterPromises: Promise<void>[] = [];

          filterKeys.forEach(filterKey => {
            // Get the column name from the URL param key
            let column = filterKey.substring(this.filterKeyPrefix.length);

            // Split the values from URL param
            let values = [];
            if (params[filterKey].includes('","')) {
              values = params[filterKey].split('","');
            } else {
              values = params[filterKey].split(",");
            }

            // Remove the (") from the value if any exists at the beginning or the end
            values = values.map(value => {
              if (value.indexOf('"') === 0) {
                value = value.substring(1);
                if (value.indexOf('"') === value.length - 1) {
                  return value.substring(0, value.length - 1);
                }
                return value;
              } else if (value.indexOf('"') === value.length - 1) {
                return value.substring(0, value.length - 2);
              }
              if (value === "null") {
                return null;
              } else {
                return value;
              }
            });

            // In case of an investment category filter, split the filter value
            // in order to retrieve each investment category value to filter
            if (column === "investment_category") {
              const categoriesValues = values[0].split(" > ");
              for (let i = 1; i <= categoriesValues.length; i++) {
                const promise = this.gridApi.getColumnFilterInstance(column + `_${i}`).then(filterInstance => {
                  if (filterInstance) {
                    // Apply the set of values as a filter to the column
                    filterInstance.setModel({
                      filterType: "set",
                      values: [categoriesValues[i - 1]]
                    });
                  }
                });
                filterPromises.push(promise);
              }
            } else if (column === "taxonomy_objective" && ["null", "not_null"].includes(values[0])) {
              values = values[0] === "null" ? [null] : taxonomyObjectives.map(o => o.id.toString());
              const promise = this.gridApi.getColumnFilterInstance(column).then(filterInstance => {
                if (filterInstance) {
                  filterInstance.setModel({
                    filterType: "set",
                    values: values
                  });
                }
              });
              filterPromises.push(promise);
            } else {
              // Get the filter instance of the column
              const promise = this.gridApi.getColumnFilterInstance(column).then(filterInstance => {
                if (filterInstance) {
                  // Apply the set of values as a filter to the column
                  filterInstance.setModel({
                    filterType: "set",
                    values: values
                  });
                } else {
                  if (column === 'has_purchase_flow' || column === 'has_initiatives') {
                    const currentFilterModel = this.gridApi.getFilterModel() || {};
                    currentFilterModel[column] = {
                      filterType: "set",
                      values: values
                    };
                    this.gridApi.setFilterModel(currentFilterModel);
                  }
                }
              });
              filterPromises.push(promise);
            }
            colsThatNeedFilterValues.push(column);
          });

          if (filterPromises.length > 0) {
            return forkJoin(filterPromises).pipe(
              tap(() => {
                this.gridApi.onFilterChanged();
                const filterModel = this.gridApi.getFilterModel();
                const filtersNb = Object.keys(filterModel).length;
                this.filtersNb = filtersNb;
                this.filteredColumns = Object.keys(filterModel);
                this.cdRef.detectChanges();
              }),
              map(() => colsThatNeedFilterValues)
            );
          }
        }
        return of(colsThatNeedFilterValues);
      })
    );
  }

  private isInputFilter(): boolean {
    const result = !!(this.investmentsListFilter && Object.keys(this.investmentsListFilter)?.length);
    return result;
  }

  private getDefaultFilterModel(): { [key: string]: any } {
    const scenarioId = this.spreadsheetColumnsService.currentMainScenarioId;
    const ids = this.spreadsheetColumnsService.nonCancelledStatusIds;
    if (scenarioId && ids.length > 0) {
      return { [`status_scenario_${scenarioId}`]: { filterType: 'set', values: ids } };
    }
    return {};
  }

  /**
   * Used to apply filters from Input (Example: displaying the table in a dialog)
   * In this case there Shouldn't be any filters in the URL
   */
  private applyInputFilters(): Observable<string[]> {
    const colsThatNeedFilterValues = [];
    if (!this.inputFiltersApplied && this.isInputFilter()) {
      const inputFilterKeys = Object.keys(this.investmentsListFilter);
      inputFilterKeys.map(column => {
        let values = this.investmentsListFilter[column].map(value => value.toString());
        // In case of an investment category filter, split the filter value
        // in order to retrieve each investment category value to filter
        if (column === "investment_category") {
          const categoriesValues = values[0].split(" > ");
          for (let i = 1; i <= categoriesValues.length; i++) {
            this.gridApi.getColumnFilterInstance(column + `_${i}`).then((filterInstance) => {
              if (filterInstance) {
                // Apply the set of values as a filter to the column
                filterInstance.setModel({
                  filterType: "set",
                  values: [categoriesValues[i - 1]]
                });
              }
            });
          }
        } else {
          // Get the filter instance of the column
          this.gridApi.getColumnFilterInstance(column).then((filterInstance) => {
            if (filterInstance) {
              // Apply the set of values as a filter to the column
              filterInstance.setModel({
                filterType: "set",
                values: values
              });
            }
          });
        }
        colsThatNeedFilterValues.push(column);
      });
    }
    return of(colsThatNeedFilterValues);
  }

  public updateGridAfterCellEditing(result: KPI.CellEditorResult) {
    this.investmentsChangesService.addChange(result.id, result.field, result.value);
  }

  private serverSideDatasource(): IServerSideDatasource {
    return {
      getRows: event => {
        this.gridApi.showLoadingOverlay();
        this.subscriptions.push(
          combineLatest([
            this.perimetersService.perimeters$,
            this.yearsToUse$,
            this.inflationService.selectedInflationHypothesis$,
            this.route.queryParams
          ])
            .pipe(
              first(),
              switchMap(([perimeters, [start_year, end_year], inflationHypothesis, urlParams]) => {
                // Only send the request to backend when the filters are ready
                if (this.finishedFirstFiltering && event.request?.valueCols?.length) {
                  const urlFilterModel = this.buildFilterModelFromURL(urlParams);
                  const gridFilterModel = this.gridApi.getFilterModel() || {};

                  let cachedFilterModel = {};
                  const hasUrlFilters = Object.keys(urlFilterModel).length > 0;
                  // Only apply cached filters if they haven't been applied yet (first load only, not on scope change)
                  if (!hasUrlFilters && Object.keys(gridFilterModel).length === 0 && !this.isInputFilter() && this.isPPA && !this.cachedFiltersAlreadyApplied) {
                    cachedFilterModel = this.getCachedFilterModel();
                    if (!Object.keys(cachedFilterModel).length) {
                      cachedFilterModel = this.getDefaultFilterModel();
                    }
                    this.cachedFiltersAlreadyApplied = true;
                  }

                  const currentFilterModel = { ...cachedFilterModel, ...gridFilterModel, ...urlFilterModel };

                  if (currentFilterModel['asset_last_evaluation']?.values) {
                    currentFilterModel['asset_last_evaluation'] = {
                      ...currentFilterModel['asset_last_evaluation'],
                      values: currentFilterModel['asset_last_evaluation'].values.map(
                        (v: any) => v !== null && v !== undefined ? Number(v) : v
                      ),
                    };
                  }

                  const urlFiltersNb = Object.keys(urlFilterModel).length;
                  const totalFiltersNb = Object.keys(currentFilterModel).length;
                  if (urlFiltersNb > 0 && Object.keys(gridFilterModel).length === 0) {
                    this.filtersNb = urlFiltersNb;
                    this.filteredColumns = Object.keys(urlFilterModel);
                    this.cdRef.detectChanges();
                  } else if (totalFiltersNb > 0 && Object.keys(gridFilterModel).length === 0 && Object.keys(cachedFilterModel).length > 0) {
                    this.filtersNb = totalFiltersNb;
                    this.filteredColumns = Object.keys(currentFilterModel);
                    this.cdRef.detectChanges();
                  }

                  event.request.sortModel = [...(event.request.sortModel || [])];
                  if (!event.request.sortModel.some(s => s.colId === 'invest_id')) {
                    event.request.sortModel.push({
                      sort: 'desc',
                      colId: 'invest_id'
                    });
                  }
                  const queryParams = {
                    ...event.request,
                    filterModel: currentFilterModel,
                    buildings: PerimetersService.getBuildingsIds(perimeters),
                    start_year,
                    end_year
                  };

                  if (!queryParams.filterModel) {
                    queryParams.filterModel = {};
                  }

                  const hasPurchaseFlowParam = urlParams[`${this.filterKeyPrefix}has_purchase_flow`];
                  if (hasPurchaseFlowParam !== undefined) {
                    const filterValue = hasPurchaseFlowParam === 'true' || hasPurchaseFlowParam === true;
                    (queryParams.filterModel as any).has_purchase_flow = {
                      filterType: "set",
                      values: [filterValue]
                    };
                  }

                  if (this.investmentsListFilter && this.investmentsListFilter.invest_id) {
                    queryParams.filterModel = {
                      ...queryParams.filterModel,
                      invest_id: {
                        filterType: "set",
                        values: this.investmentsListFilter.invest_id
                      }
                    };
                  }

                  if (inflationHypothesis) {
                    queryParams["inflation_hypothesis"] = inflationHypothesis.id;
                  }
                  return this.spreadsheetColumnsService.getInvestmentsData(queryParams);
                } else {
                  // If filters are not ready, return an empty array
                  return of({
                    lastRow: 0,
                    rowCount: 0,
                    rowData: [],
                    rowMax: 0,
                    totalBudget: 0,
                    forcedEmptyWhileLoading: true
                  });
                }
              })
            )
            .subscribe(
              data => {
                // If filters are not ready, return an empty array
                if (data["forcedEmptyWhileLoading"]) {
                  this.gridApi.showLoadingOverlay();
                  delete data["forcedEmptyWhileLoading"];

                  data.rowCount = 1;
                  data.lastRow = 1;
                  data.rowData = [
                    {
                      label: "",
                      id: 0,
                      budget: 0,
                      payback: 0
                    }
                  ];
                  this.updateTotalInvestmentBudget(0, 0, 0);
                } else {
                  this.gridApi.hideOverlay();

                  if (data["rowCount"] === 0) {
                    this.gridApi.showNoRowsOverlay();
                  }
                  this.updateTotalInvestmentBudget(data["rowCount"], data["totalBudget"], data["rowMax"]);
                }

                this.gridApi.hideOverlay();

                const filteredRows = (data.rowData || []).filter(row => !!row.id && row.id !== 0);
                const hiddenRowsCount = (data.rowData || []).length - filteredRows.length;
                const adjustedRowCount = (data.rowCount || 0) - hiddenRowsCount;

                event.success({
                  ...data,
                  rowData: filteredRows,
                  rowCount: adjustedRowCount,
                  lastRow: adjustedRowCount
                });
                this.selectNewInvestmentRow();
              },
              error => {
                this.gridApi.hideOverlay();
                console.error(error);
                event.fail();
              }
            )
        );
      }
    };
  }

  private get yearsToUse$(): Observable<[number, number]> {
    const yearPartialKey = `${INVEST_FILTER_KEY_PREFIX}year_scenario_`;
    return combineLatest([this.yearsService.latestYears$, this.route.queryParams]).pipe(
      map(([[start_year, end_year], params]) => {
        let yearParam: number;
        const yearKey = params ? Object.keys(params).find(key => key.includes(yearPartialKey)) : null;
        if (yearKey) {
          const isOnlyOneYear = !params[yearKey].includes(",");
          if (isOnlyOneYear) {
            yearParam = Number(params[yearKey]);
          }
        }
        if (params && params["applyPeriod"]) {
          this.applyPeriod = params["applyPeriod"] === "false" ? false : true;
        }
        return [
          this.applyPeriod ? (yearParam ? Math.min(yearParam, start_year) : start_year) : 2000,
          this.applyPeriod ? (params && yearParam ? Math.max(yearParam, end_year) : end_year) : 2100
        ];
      })
    );
  }

  private getInvestmentTagIds(investmentRow: RowNode): number[] {
    return Object.keys(investmentRow?.data)
      .filter(key => key.includes("investment_reason_") && !!investmentRow?.data[key])
      .map(key => Number(key.replace("investment_reason_", "")));
  }

  public ngOnDestroy() {
    this.subscriptions.push(
      this.isUrlParamsFilters()
        .pipe(
          filter((isUrlParamsFilters) => isUrlParamsFilters),
          first()
        )
        .subscribe(() => {
          this.quickFiltersService.setFiltersFromSpreadsheet("investment", {});
        })
    );
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  private getClosingMessage(rowNodes: RowNode[]): string {
    const isCreationOfEquipment = rowNodes.every(rowNode => {
      const investmentType = this.investmentTypes.find(type => type.id === rowNode.data?.["investment_type"]);
      return !!investmentType?.creation_of_equipment;
    });
    return isCreationOfEquipment
      ? this.translate.instant(
          "Closing an investment of type \"Equipment creation\" automatically creates the new equipment in the equipment database once the investment is closed"
        )
      : this.translate.instant(
          "Closing an investment enables future equipment to be activated and old equipment to be archived if it is being replaced"
        );
  }

  private generateToStatusSubmenu(
    scenario: KPI.InvestmentScenario,
    only1Scenario: boolean,
    rowNodes: RowNode[]
  ): MenuItemDef | MenuItemDef[] {
    const scenarioInvestmentsIds = [
      ...new Set(
        rowNodes.map(rowNode => {
          if (rowNode && rowNode.data && rowNode.data[`id_scenario_${scenario.id}`]) {
            return Number(rowNode.data[`id_scenario_${scenario.id}`]);
          }
        })
      )
    ];
    const oldStatusId = rowNodes[0].data[`status_scenario_${scenario.id}`];
    const oldStatus = this.investmentStatuses.find(s => s.id === oldStatusId);
    const availableTransitionsId = this.allowedTransitions
      .filter(t => t.from_status === oldStatusId)
      .map(t => t.to_status); // Available transitions for 'statusFrom'
    const toStatuses = this.investmentStatuses.filter(s => {
      return availableTransitionsId.includes(s.id);
    });

    const hasPlannedProject = rowNodes.some((rowNode) =>
      rowNode.data?.["projects"]?.some((project: Partial<KPI.Project>) =>
        project.instances?.find(i => i.scenario?.id === scenario.id && i.status?.is_request)
      )
    );

    // Statuses ids available for transition
    // check every rows investment_status is the same
    const areStatusesEquals = rowNodes.every((rowNode) => {
      if (rowNodes[0]?.data?.[`status_scenario_${scenario.id}`]) {
        return (
          rowNode.data &&
          rowNode.data[`status_scenario_${scenario.id}`] === rowNodes[0].data[`status_scenario_${scenario.id}`]
        );
      } else {
        return false;
      }
    });

    const nodesRounds = rowNodes.map((node) => node.data?.["workflow_round"]).some(round => round !== 0);

    const budgetYear = rowNodes[0]?.data?.[`year_scenario_${scenario.id}`];
    const currentYear = new Date().getFullYear();
    const shouldDisableClosed = budgetYear && budgetYear > currentYear;

    const toStatusSubMenu = toStatuses.map(status => {
      const blockedByProject = hasPlannedProject && status.hypothesis;
      const blockedByFutureYear = shouldDisableClosed && status.is_closed;
      return {
        name: status.name,
        disabled: !areStatusesEquals || nodesRounds || blockedByProject || blockedByFutureYear,
        tooltip: !areStatusesEquals
          ? this.translate.instant("Please select investments with the same status")
          : nodesRounds
          ? this.translate.instant("Impossible to modify the stage: investment(s) present in a validation round")
          : blockedByProject
          ? this.translate.instant(
              "The investment is linked to a planned project, please change the status of the project first"
            )
          : blockedByFutureYear
          ? this.translate.instant("Cannot close the item(s) in the future")
          : "",
        action: () => {
          if (scenarioInvestmentsIds?.length > 1) {
            const context = {
              investmentsIds: scenarioInvestmentsIds,
              fromStatus: oldStatus.name,
              toStatus: status.name,
              scenario,
            };
            if (status.is_closed && scenario.is_main) {
              context["closingPrecision"] = this.getClosingMessage(rowNodes);
            }
            const dialog = this.dialogService.open(InvestmentChangeConfirmDialogComponent, {
              autoFocus: false,
              context
            });
            this.subscriptions.push(
              dialog.onClose.pipe(filter((res) => !!res)).subscribe(() => {
                this.updateInvestmentStatus(scenarioInvestmentsIds, oldStatusId, status.id);
              })
            );
          } else if (status.is_cancelled) {
            const dialog = this.dialogService.open(BasicDialogComponent, {
              autoFocus: false,
              context: {
                title: this.translate.instant("Investment cancellation"),
                content: this.translate.instant(
                  "Are you sure you want to cancel this investment? This action can not be undone"
                )
              }
            });
            this.subscriptions.push(
              dialog.onClose.subscribe((res) => {
                if (res) {
                  this.updateInvestmentStatus(scenarioInvestmentsIds, oldStatusId, status.id);
                }
              })
            );
          } else if (status.is_closed && scenario.is_main) {
            const dialog = this.dialogService.open(BasicDialogComponent, {
              autoFocus: false,
              context: {
                title: this.translate.instant("Investment closing"),
                content: this.getClosingMessage(rowNodes)
              }
            });
            this.subscriptions.push(
              dialog.onClose.subscribe((res) => {
                if (res) {
                  this.updateInvestmentStatus(scenarioInvestmentsIds, oldStatusId, status.id);
                }
              })
            );
          } else {
            this.updateInvestmentStatus(scenarioInvestmentsIds, oldStatusId, status.id);
          }
        }
      };
    });

    return only1Scenario
      ? toStatusSubMenu
      : {
          disabled: !toStatuses?.length || !areStatusesEquals,
          name: scenario.name,
          cssClasses: this.showScenarii ? [`scenario-${scenario.id}`] : [],
          tooltip: !toStatuses?.length
            ? this.translate.instant("No status available from the current status")
            : !areStatusesEquals
            ? this.translate.instant("Please select investments with the same status")
            : "",
          subMenu: toStatusSubMenu
        };
  }

  private generateToYearsSubmenu(
    scenario: KPI.InvestmentScenario,
    only1Scenario: boolean,
    rowNodes: RowNode[]
  ): MenuItemDef | MenuItemDef[] {
    const scenarioInvestmentsIds = [
      ...new Set(
        rowNodes.map((rowNode) => {
          if (rowNode && rowNode.data && rowNode.data[`id_scenario_${scenario.id}`]) {
            return Number(rowNode.data[`id_scenario_${scenario.id}`]);
          }
        })
      )
    ];

    const fromYear = rowNodes[0]?.data?.[`year_scenario_${scenario.id}`];
    const toYears = R.range(new Date().getFullYear(), new Date().getFullYear() + 26);
    const areStatusRequestOrHypothesis = rowNodes.every(rowNode => {
      const status = rowNode?.data?.[`status_scenario_${scenario.id}`]
        ? this.investmentStatuses.find(s => s.id === rowNode.data[`status_scenario_${scenario.id}`])
        : null;
      return status?.hypothesis || status?.is_request;
    });

    const requestOrHypothesisStatuses: string = this.investmentStatuses
      .filter((s) => s.hypothesis || s.is_request)
      .map((s) => s.name)
      .join(", ");

    // check every rows investment_status is the same
    const areYearsEquals = rowNodes.every((rowNode) => {
      if (rowNodes[0]?.data?.[`year_scenario_${scenario.id}`]) {
        return (
          rowNode.data &&
          rowNode.data[`year_scenario_${scenario.id}`] === rowNodes[0].data[`year_scenario_${scenario.id}`]
        );
      } else {
        return false;
      }
    });
    const scenarioDisabled = !areYearsEquals || !areStatusRequestOrHypothesis;

    const tooltip = !areYearsEquals
      ? this.translate.instant("Please select investments with the same year")
      : !areStatusRequestOrHypothesis
      ? this.translate.instant("Please select investments in one of these statuses") +
        ` : ${requestOrHypothesisStatuses}`
      : "";

    const toYearsSubMenu = toYears.map((toYear) => {
      return {
        name: toYear.toString(),
        disabled: scenarioDisabled || toYear === fromYear,
        tooltip: scenarioDisabled
          ? tooltip
          : toYear === fromYear
          ? this.translate.instant("The new year must be different from the current one")
          : "",
        subMenu: this.reasons
          .sort((a, b) => a.ordering - b.ordering)
          .map(reason => {
            return {
              name: reason.name,
              action: () => {
                if (scenarioInvestmentsIds?.length > 1) {
                  const dialog = this.dialogService.open(InvestmentChangeConfirmDialogComponent, {
                    autoFocus: false,
                    context: {
                      investmentsIds: scenarioInvestmentsIds,
                      fromYear,
                      toYear,
                      scenario,
                      reasonId: reason.id,
                    }
                  });
                  this.subscriptions.push(
                    dialog.onClose.pipe(filter(res => !!res.confirmed)).subscribe(res => {
                      this.changeInvestmentsYear(scenarioInvestmentsIds, fromYear, toYear, res.reasonId);
                    })
                  );
                } else {
                  this.changeInvestmentsYear(scenarioInvestmentsIds, fromYear, toYear, reason.id);
                }
              }
            };
          })
      };
    });

    return only1Scenario
      ? toYearsSubMenu
      : {
          disabled: scenarioDisabled,
          name: scenario.name,
          cssClasses: this.showScenarii ? [`scenario-${scenario.id}`] : [],
          tooltip,
          subMenu: toYearsSubMenu
        };
  }

  public clearSelection() {
    this.gridApi.deselectAll();
    this.gridApi.clearRangeSelection();
    this.gridApi.clearFocusedCell();

    this.selectedRowsNb = this.gridApi.getSelectedRows().length;
    this.cdRef.detectChanges();
  }

  private getSelectedRows(): RowNode<any>[] {
    const selectedRanges = this.gridApi.getCellRanges();
    const selectedNodes: Set<RowNode<any>> = new Set();

    if (selectedRanges?.length) {
      selectedRanges.forEach((range) => {
        const startIndex = range.startRow?.rowIndex;
        const endIndex = range.endRow?.rowIndex;

        if (startIndex != null && endIndex != null) {
          const from = Math.min(startIndex, endIndex);
          const to = Math.max(startIndex, endIndex);

          for (let i = from; i <= to; i++) {
            const node = this.gridApi.getDisplayedRowAtIndex(i);
            if (node) {
              selectedNodes.add(node as unknown as RowNode<any>);
            }
          }
        }
      });
    }

    return Array.from(selectedNodes);
  }

  private setSelectedRowsNb() {
    this.selectedRowsNb = this.getSelectedRows().length;
    const rowNodes = [];
    this.gridApi.forEachNode(node => {
      if (node?.data?.id) rowNodes.push(node);
    });
    this.loadedRowsNb = rowNodes.length;
    this.cdRef.detectChanges();
  }



  private bulkUpdateInvestmentQuotePart(rowNodes: RowNode[], quotePart: QuotePartItem) {
    const ids = [...new Set(rowNodes.map(r => r.data?.id).filter(Boolean))] as number[];
    if (!ids.length) return;
    forkJoin(ids.map(id =>
      this.investmentsService.updateInvestment(id, { quote_part_id: quotePart.id })
    )).pipe(
      tap(() => { this.saveToast.showSaved()}),
      tap(() => this.gridApi.refreshServerSide())
    ).subscribe({
      error: (err) => console.error(err)
    });
  }

  public resetGrid(): void {
    const gridApi = this.gridApi;
    gridApi.resetColumnState();
    gridApi.resetColumnGroupState();
    gridApi.setFilterModel(null);
    gridApi.paginationGoToFirstPage();
    gridApi.ensureIndexVisible(0);
    gridApi.refreshCells({ force: true });
  }

  public openLinkedInvestmentsList(rowData: any): void {
    const investId = rowData['invest_id'];
    const linkedTo = rowData['linked_to'];

    this.sideFormService.open(LinkableInvestmentsListComponent, {
      autoFocus: false,
      context: {
        mainInvestmentId: investId,
        linkedToId: linkedTo || null,
        readOnly: false,
        canLink: false,
        multipleChoice: false,
        startYear: 1950,
        endYear: 2100,
      },
    });
  }

  showInvestmentWizard() {
    const ref = this.sideFormService.open(
      InvestmentWizardRootComponent,
      {
        autoFocus: true,
        closeOnBackdropClick: false,
        closeOnEsc: false,
      },
    );
    ref.onClose.pipe(
      first(),
      filter(investCreated => !!investCreated)
    ).subscribe(() => {
      this.gridApi.refreshServerSide();
    });
  }

  private reorderScenarioColumns(): void {
    if (!this.gridApi || !this.showScenarii || !this.scenarii?.length) {
      return;
    }

    const allColumns = this.gridApi.getAllGridColumns();
    const mainScenario = this.scenarii.find(s => s.is_main);

    if (!mainScenario) {
      return;
    }

    const mainScenarioColumns = allColumns.filter(col => {
      const parentDef = col.getParent()?.getColGroupDef();
      return parentDef?.headerClass === `scenario-${mainScenario.id}`;
    });

    const altScenarioColumns = allColumns.filter(col => {
      const parentDef = col.getParent()?.getColGroupDef();
      return parentDef?.headerClass &&
             typeof parentDef.headerClass === 'string' &&
             parentDef.headerClass.includes('scenario-') &&
             parentDef.headerClass !== `scenario-${mainScenario.id}`;
    });

    if (mainScenarioColumns.length === 0 || altScenarioColumns.length === 0) {
      return;
    }

    const lastMainScenarioCol = mainScenarioColumns[mainScenarioColumns.length - 1];
    const targetIndex = allColumns.indexOf(lastMainScenarioCol) + 1;
    const altScenarioColIds = [...new Set(altScenarioColumns.map(col => col.getColId()))];

    setTimeout(() => {
      this.gridApi.moveColumns(altScenarioColIds, targetIndex);
    }, 100);
  }

  private selectNewInvestmentRow() {
    if (this.newInvestment) {
      this.newInvestmentId = this.newInvestment.id;
      setTimeout(() => {
        // Due to a bug with the rows numbers (the number 1 is duplicated when a new row gets added
        // in the 1st position), we have to redraw the rows. We do it in a settimout because I prefer
        // to let the "row adding" animation finish.
        this.gridApi.redrawRows();
        const newInvestRow = this.gridApi.getRowNode(this.newInvestment.id.toString());
        if (newInvestRow) {
          newInvestRow.setSelected(true);
        }
        this.newInvestment = null;
      }, 400);
    }
  }
}
